import { v4 as uuid4 } from 'uuid';

export const useToastAlerts = defineStore('toastAlerts', {
  state: () => {
    // Holds any default values for ToastAlerts
    const defaults: ToastAlertDefaults = {
      // dismissable: true,
      dismissAfter: 3000,
    };
    return {
      alerts: [] as ToastAlert[],
      defaults,
    };
  },
  actions: {
    add(alert: ToastAlertConfig) {
      const alertConfig = Object.assign({}, this.defaults, alert, {
        id: uuid4(),
      });
      if (alertConfig.dismissAfter) {
        setTimeout(() => this.remove(alertConfig.id), alertConfig.dismissAfter);
      }
      this.alerts.push(alertConfig);
    },
    remove(id: string) {
      this.alerts = this.alerts.filter(alert => alert.id !== id);
    },
    success(message: string, config: Partial<ToastAlertConfig> = {}) { this.add({ ...config, type: 'success', message }); },
    error(message: string, config: Partial<ToastAlertConfig> = {}) { this.add({ ...config, type: 'error', message }); },
    info(message: string, config: Partial<ToastAlertConfig> = {}) { this.add({ ...config, type: 'info', message }); },
    warning(message: string, config: Partial<ToastAlertConfig> = {}) { this.add({ ...config, type: 'warning', message }); },
  },
});
